'use strict';

(function(){
  var module = angular.module('client.components');

  controller.$inject = ['ActiveMode', 'spireReportingService', 'spireReportingModels', 'reportToPDF', 'ClassesService', '$routeParams', 'ReportingSchoolYearsService', '$log'];

function controller (ActiveMode, spireReportingService, spireReportingModels, reportToPDF, ClassesService, $routeParams, ReportingSchoolYearsService, $log) {
  var ctrl = this;

  ctrl.inited = false;
  ctrl.reportLoadError = false;
  ctrl.isPrinting = false;
  ctrl.data = {};
  ctrl.filterYears = ReportingSchoolYearsService.get();
  ctrl.year = null;
  ctrl.filterYear = null;
  ctrl.includeArchived = false;
  let reportRequest;

  ctrl.viewValues = spireReportingModels.viewValues;

  function setReportingYear(selection) {
    if (!selection) {
      return false;
    }
    const changed = ctrl.filterYear !== selection;
    ctrl.year = selection.value;
    ctrl.filterYear = selection;
    ctrl.includeArchived = selection.archived === true;
    return changed;
  }

  function initReportingYear() {
    setReportingYear(ctrl.filterYears[0]);
  }

  function getReportFilter() {
    const reportFilter = {
      include_archived: ctrl.includeArchived,
      year: ctrl.year
    };
    if ($routeParams.class) {
      reportFilter.class_id = $routeParams.class;
    }
    return reportFilter;
  }

  function fetchAndUpdateReport() {
    ctrl.inited = false;
    ctrl.reportLoadError = false;
    const request = ActiveMode.getReportData(getReportFilter()).then(function(data) {
      // A slower response from an earlier year must not replace the current report.
      if (request !== reportRequest) {
        return false;
      }
      parseReportData(data);
      ctrl.reportLoadError = false;
      ctrl.inited = true;
      return true;
    }).catch(function(error) {
      if (request === reportRequest) {
        handleReportLoadError(error);
      }
      return false;
    });
    reportRequest = request;
    return request;
  }

  function handleReportLoadError(error) {
    $log.error("error in loading SPIRE student summary report:", error);
    ctrl.reportLoadError = true;
    ctrl.inited = true;
  }

  ReportingSchoolYearsService.ready().then(function() {
    initReportingYear();
    return fetchAndUpdateReport();
  }).catch(handleReportLoadError);

  ctrl.onRefresh = function(student, level, year) {
    // Just set the current student in the controller
    if (student) {
      ctrl.data.student = student;
    }

    // Filter data by specified level
    if (level) {
      ctrl.data.level = level.id;
    }

    if (setReportingYear(year) || ctrl.reportLoadError) {
      return fetchAndUpdateReport();
    }

    if (ctrl.inited) {
      selectLevel(ctrl.data.level);
    }
    return reportRequest;
  };

  function selectLevel(selectedLevel) {
    ctrl.data.level = ctrl.levels.find(function(level) { return String(level) === String(selectedLevel); }) || ctrl.levels[ctrl.levels.length - 1] || null;
  }

  ctrl.downloadPDF = function (){
    reportToPDF.createReportToPDF(ctrl)('printable', 'Student Summary Report', 'scrollingdiv', [1250, 1000], 'portrait');
  };


  ctrl.lastUpdate = function() {
    return window.moment().format('M/DD/YYYY');
  };

  function studentHasData() {
    return ctrl.models[ctrl.viewValues.placement].getStudentHasData(ctrl.data.student) ||
            ctrl.models[ctrl.viewValues.ca].getStudentHasData(ctrl.data.student, ctrl.data.level) ||
            ctrl.models[ctrl.viewValues.cmfd].getStudentHasData(ctrl.data.student, ctrl.data.level) ||
            ctrl.models[ctrl.viewValues.prepost].getStudentHasData(ctrl.data.student, ctrl.data.level) ||
            ctrl.models[ctrl.viewValues.mid].getStudentHasData(ctrl.data.student, ctrl.data.level);
  }

  function parseReportData(data) {
    var classes = spireReportingService.parseClassNames(data.students);
    var students = spireReportingService.parseStudents(data.students, data.otherStudents);
    var lessons = spireReportingService.parseToLevels(data.lessons, 'lesson');
    var concepts = spireReportingService.parseToLevels(data.concepts, 'concept');
    var levels = spireReportingService.getLevels(lessons);

    ctrl.models = {};
    ctrl.models[ctrl.viewValues.placement] = spireReportingModels.getPlacementTableModel(students, data.levels, data.placements);
    ctrl.models[ctrl.viewValues.ca] = spireReportingModels.getCAStudentDataTableModel(students, lessons, data.ca);
    ctrl.models[ctrl.viewValues.cmfd] = spireReportingModels.getCMFDStudentDataTableModel(students, concepts, data.cmfd);
    ctrl.models[ctrl.viewValues.prepost] = spireReportingModels.getPrePostTableModel(students, data.pre);
    ctrl.models[ctrl.viewValues.mid] = spireReportingModels.getMidTableModel(students, lessons, data.mid);

    ctrl.students = spireReportingModels.sortStudents(students);

    const selectedStudentId = ctrl.data.student && ctrl.data.student.id;

    // Default to the first student in the list
    if (ctrl.students && ctrl.students.length) {
      if ($routeParams.student) {
        const routeStudentId = parseInt($routeParams.student, 10);
        ctrl.data.student = ctrl.students.find(function(student) { return student.id === routeStudentId; }) || ctrl.students[0];
      }
      else if (selectedStudentId) {
        ctrl.data.student = ctrl.students.find(function(student) { return student.id === selectedStudentId; }) || ctrl.students[0];
      }
      else {
        ctrl.data.student = ctrl.students[0];
      }
    }

    // Initialize local levels reference.  Set default level to last (latest)
    ctrl.levels = levels;
    selectLevel(ctrl.data.level);

    // Create a list for filter display
    ctrl.filterLevels = [];
    levels.forEach(function(level) {
      var name = "Level " + level;
      ctrl.filterLevels.push({id: level, name: name });
    });

    // Set classes for use in filter
    if (classes && classes.length) {
      if (!ctrl.data.classId) {
        ctrl.data.classId = classes[0].id;
      }
    }
    else if (data.class_id) {
      ctrl.data.classId = data.class_id;
      ClassesService.getClassName(ctrl.data.classId).then(function(className) {
        ctrl.data.clasName = className;
      });
    }
  }

  ctrl.reportHasData = function() {
    return ctrl.students && ctrl.students.length;
  };

  ctrl.reportHasStudentData = function() {
    return ctrl.reportHasData() && studentHasData();
  };

}

module.component('xpSpireStudentSummary', {
  template: require('./spireStudentSummary.jade'),
  controller: controller,
});

})();
